/**
 * @copyright 2019 @ DigiNet
 * @author XUANVINH
 * @create 2019/01/11 10:37
 * @update 2019/01/11 10:37
 * @file src/components/header/header.js
 */

import React from 'react';
import {connect} from "react-redux";
import PopupView from "../popup/popup-view";

import EventTracking from "../common/tracking/event";
import Config from "../../config";
import * as w19F1001Actions from "../../actions/w19/w19F1001/w19F1001-actions";
import {bindActionCreators} from "redux";
import notify from "devextreme/ui/notify";
import PropTypes from 'prop-types';
import { Row, Col, Button, Toggle } from 'diginet-core-ui/components';

const generalBtnProp = {
    size: 'small',
    labelProps: { style: { color: 'initial' } }
};
class W19F1001_Popup extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state={
            aStatus: false,
            approveNote:'',
            approveUser:'',
            isSaved:false
        };
    }

    onHide(){
        const {onHide}=this.props;
        if(onHide){
            onHide(this.state.isSaved&&this.state);
        }
    }

    toggleButton(e){
        this.setState({ aStatus: !!e?.value })
    }

    componentDidMount(){
        const {aStatus,approveNote}=this.props;
        this.setState({
            aStatus:aStatus===1?true:!!aStatus,
            approveNote:approveNote
        });

    }

    saveDataPop(){
        const aStatus=this.state.aStatus?'1':'0';
        const approveNotesU=document.getElementById('approveNotesUW19F1001').value;
        const {quotationID}=this.props;
        const param={
            QuotationID:quotationID,
            AStatus:aStatus,
            ApproveNotesU:approveNotesU
        };

        this.props.w19F1001Actions.savePopUp(param,  (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            }
                if(data.code===200){
                    this.setState({
                        isSaved:true
                    });
                    notify(Config.lang('Duyet_thanh_cong'), "success", 400);
                }
        });
    }

    render() {
        const {approveNote,aStatus,isSaved}=this.state;
        return (
            <PopupView
                title={Config.lang('Duyet_bao_gia')}
                show={true}
                animation={true}
                onHide={() => this.onHide()}>
                <EventTracking action={"FORM"} label={"W19F1001_Popup"} />
                <div className={'page-container mgb4x'}>
                    <Row>
                        <Col md={2} sm={2} xs={12} lg={2}>
                            <Toggle
                                checked={aStatus}
                                disabled={aStatus && isSaved}
                                onChange={(e) => this.toggleButton(e)}
                            />
                        </Col>
                        <Col md={10} sm={10} xs={12} lg={10}>
                            <textarea disabled={aStatus && isSaved} id={'approveNotesUW19F1001'} className={'form-control'} rows={5} onChange={(e) => {
                                this.setState({
                                    approveNote: e?.target?.value || ''
                                });
                            }} value={approveNote} />
                        </Col>
                        <Col md={12} sm={12} xs={12} lg={12} className={'text-right'}>
                            <Button
                                {...generalBtnProp}
                                color={'info'}
                                startIcon={'Save'}
                                disabled={aStatus && isSaved}
                                label={Config.lang('Lưu')}
                                onClick={() => this.saveDataPop()}
                            />
                        </Col>
                    </Row>
                </div>
            </PopupView>
        )
    }
}
W19F1001_Popup.propTypes = {
    approveNote:PropTypes.string,
    aStatus:PropTypes.bool,
    approveUser:PropTypes.string,
    quotationID:PropTypes.string,
};
export default connect(null,
    (dispatch) => ({
        w19F1001Actions: bindActionCreators(w19F1001Actions, dispatch)
    }))(W19F1001_Popup);